import React, { useEffect, createElement } from 'react';
type MetaEventName = 'PageView' | 'ViewContent' | 'InitiateCheckout' | 'Contact';
type MetaEventParams = Record<string, string | number>;
interface FbqFunction {
  (...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push?: FbqFunction;
  loaded?: boolean;
  version?: string;
}
declare global {
  interface Window {
    fbq?: FbqFunction;
    _fbq?: FbqFunction;
  }
}
const pixelId = '3991790347792819';
export function trackMetaEvent(eventName: MetaEventName, parameters?: MetaEventParams) {
  if (typeof window === 'undefined' || !window.fbq) {
    return;
  }
  if (parameters) {
    window.fbq('track', eventName, parameters);
    return;
  }
  window.fbq('track', eventName);
}
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }
    if (!window.fbq) {
      const fbq = ((...args: unknown[]) => {
        if (fbq.callMethod) {
          fbq.callMethod(...args);
        } else {
          fbq.queue.push(args);
        }
      }) as FbqFunction;
      fbq.queue = [];
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      window.fbq = fbq;
      window._fbq = fbq;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    window.fbq('init', pixelId);
    trackMetaEvent('PageView');
    trackMetaEvent('ViewContent', {
      content_name: 'Mega Pack de Recursos Docentes',
      content_type: 'product',
      value: 21990,
      currency: 'ARS'
    });
  }, []);
  return <noscript data-id="element-81">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`} alt="" data-id="element-82" />
    </noscript>;
}